import { Component } from '@angular/core';
import { Params } from '@angular/router';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterNumberType } from './covance-filter-number-type';

@Component({
    selector: 'covance-filter-number-type',
    template: require('./covance-filter-number-type.component.html')
})
export class CovanceFilterNumberTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterNumberType> {
    constructor(filter: CovanceFilterNumberType) {
        super(filter);
    }

    protected setFilterQueryParam(queryParams: Params) {
        if (!isNaN(+this.fieldVal.queryParamValue)) {
            queryParams[this.fieldVal.queryParamValue] = this.fieldVal.queryParamValue;
        }
    }
}